// Utility to convert Windows color value to Hex color string and vice versa

/**
 * Converts a Windows color value to a hexadecimal color string.
 * @param {number} color - The Windows color value.
 * @return {string} The hexadecimal color string.
 */
export const windowsColorToHex = (color) => {
  if (typeof color !== "number" || color < 0 || color > 16777215) {
    return "rgb(255, 255, 255)";
  }

  const b = (color & 0xff0000) >> 16;
  const g = (color & 0x00ff00) >> 8;
  const r = color & 0x0000ff;

  const toHex = (c) => c.toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

/**
 * Converts a hexadecimal color string to a Windows color value.
 * @param {string} hex - The hexadecimal color string.
 * @return {number} The Windows color value.
 */
export const hexToWindowsColor = (hex) => {
  hex = hex.substring(0, 7);

  if (
    typeof hex !== "string" ||
    !/^#?([0-9a-fA-F]{6})([0-9a-fA-F]{2})?$/.test(hex)
  ) {
    return 16777215;
  }

  if (hex.length === 8) {
    hex = hex.substring(2);
  }

  hex = hex.replace(/^#/, "");

  // Parse the hex string to get RGB components
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Combine the BGR components into a single integer
  const bgrInt = (b << 16) | (g << 8) | r;

  return bgrInt;
};

// Example usage:
// const hexColor = windowsColorToHex(16777215); // #FFFFFF
// const windowsColor = hexToWindowsColor('#00AE00'); // 44544
